import { formatInTimeZone } from 'date-fns-tz';
import type { Notice, NoticeCategory } from '@/api/hanly-v2/hanlyAPIV2.schemas';
import { TENANT_TIME_ZONE } from '@/utils/date';

export const NOTICE_CATEGORY_LABELS: Record<NoticeCategory, string> = {
  NEW_FEATURE: '新機能',
  IMPROVEMENT: '改善',
  BUG_FIX: '不具合の修正',
  MAINTENANCE: 'メンテナンス',
};

/** マニュアル */
export const MANUAL_URL = 'https://manual.animal-office.jp/';

/** 公開日をテナントのTZの日付で表示する(NEW の判定も API がテナントのTZの暦日で行う) */
export const formatNoticeDate = (publishedAt: string) =>
  formatInTimeZone(publishedAt, TENANT_TIME_ZONE, 'yyyy/MM/dd');

export const NewMark = () => (
  <span className="flex-none bg-sky-700 px-1.5 text-xs font-bold leading-5 text-white">NEW</span>
);

export const ImportantMark = () => (
  <span className="flex-none bg-red-600 px-1.5 text-xs font-bold leading-5 text-white">重要</span>
);

interface NoticeMarksProps {
  notice: Notice;
}

export const NoticeMarks = ({ notice }: NoticeMarksProps) => (
  <>
    {notice.is_important && <ImportantMark />}
    {notice.is_new && <NewMark />}
  </>
);
